import { apiSlice } from "../api/apiSlice";

export const generatorDaywiseComsumptionApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getDateWiseOilConsumption: builder.mutation({
      query: (data) => ({
        url: "/apiV2/generator/day-data-list",
        method: "POST",
        body: data,
      }),
    }),
  }),
});

export const { useGetDateWiseOilConsumptionMutation } =
  generatorDaywiseComsumptionApi;
